import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  allSection: [],
  singleSection: null,
  isCreatingSection: false,
  isCreatingSectionMedia: false,
  isEditingSection: false,
  isEditingSectionMedia: false,
  isDeletingSection: false,
  isLoadingAllSection: false,
  isLoadingSingleSection: false,
  error: null,
};

export const sectionSlice = createSlice({
  name: "section",
  initialState,
  reducers: {
    createSectionStart: (state, action) => {
      state.isCreatingSection = true;
      state.error = null;
    },
    createSectionSuccess: (state, action) => {
      state.isCreatingSection = false;
    },
    createSectionFailure: (state, action) => {
      state.isCreatingSection = false;
      state.error = action.payload;
    },
    getAllSectionStart: (state, action) => {
      state.isLoadingAllSection = true;
      state.error = null;
      state.allSection = [];
    },
    getAllSectionSuccess: (state, action) => {
      state.isLoadingAllSection = false;
      state.error = null;
      state.allSection = action.payload;
    },
    getAllSectionFailure: (state, action) => {
      state.isLoadingAllSection = false;
      state.error = action.payload;
      state.allSection = [];
    },
    getSectionStart: (state, action) => {
      state.isLoadingSingleSection = true;
      state.error = null;
    },
    getSectionSuccess: (state, action) => {
      state.isLoadingSingleSection = false;
      state.singleSection = action.payload;
      state.error = null;
    },
    getSectionFailure: (state, action) => {
      state.isLoadingSingleSection = false;
      state.error = action.payload;
    },
    editSectionStart: (state, action) => {
      state.isEditingSection = true;
    },
    editSectionSuccess: (state, action) => {
      state.isEditingSection = false;
    },
    editSectionFailure: (state, action) => {
      state.isEditingSection = false;
      state.error = action.payload;
    },
    deleteSectionStart: (state, action) => {
      state.isDeletingSection = true;
    },
    deleteSectionSuccess: (state, action) => {
      state.isDeletingSection = false;
    },
    deleteSectionFailure: (state, action) => {
      state.isDeletingSection = false;
      state.error = action.payload;
    },
    createSectionMediaStart: (state) => {
      state.isCreatingSectionMedia = true;
      state.isCreatingSection = true;
    },
    createSectionMediaSuccess: (state) => {
      state.isCreatingSectionMedia = false;
      state.isCreatingSection = false;
    },
    createSectionMediaFailure: (state, action) => {
      state.isCreatingSectionMedia = false;
      state.isCreatingSection = false;
      state.error = action.payload;
    },
    editSectionMediaStart: (state) => {
      state.isEditingSectionMedia = true;
      state.isEditingSection = true;
    },
    editSectionMediaSuccess: (state) => {
      state.isEditingSectionMedia = false;
      state.isEditingSection = false;
    },
    editSectionMediaFailure: (state, action) => {
      state.isEditingSectionMedia = false;
      state.isEditingSection = false;
      state.error = action.payload;
    },
    resetSingleSection: (state, action) => {
      state.singleSection = null;
    },
  },
});

export const {
  createSectionStart,
  createSectionSuccess,
  createSectionFailure,
  getAllSectionStart,
  getAllSectionSuccess,
  getAllSectionFailure,
  getSectionStart,
  getSectionSuccess,
  getSectionFailure,
  resetGetSectionLoading,
  editSectionStart,
  editSectionSuccess,
  editSectionFailure,
  deleteSectionStart,
  deleteSectionSuccess,
  deleteSectionFailure,
  createSectionMediaFailure,
  createSectionMediaStart,
  createSectionMediaSuccess,
  editSectionMediaFailure,
  editSectionMediaStart,
  editSectionMediaSuccess,
  resetSingleSection,
} = sectionSlice.actions;

const sectionReducer = sectionSlice.reducer;
export default sectionReducer;
